// Single source of truth for GA4 custom events. Import `track` everywhere — never call
// window.gtag directly. No-ops on the server.
//
// Every event is ALSO mirrored first-party (POST /api/track → "AnalyticsEvent") so we keep
// the numbers when GA is ad-blocked. That mirror happens exactly once, here — call sites must
// NOT call trackEvent() from '@/lib/analytics/client' as well, or the event double-posts.
import { trackEvent } from '@/lib/analytics/client';

type Params = Record<string, string | number | boolean | undefined>;

export function track(event: string, params: Params = {}) {
  if (typeof window === 'undefined') return;
  try { trackEvent(event, params); } catch { /* best-effort */ }
  const g = (window as any).gtag;
  if (typeof g !== 'function') return; // no-op in dev / if GA blocked
  g('event', event, params);
}
